import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-sprite',
  templateUrl: './sprite.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpriteComponent {}
